import * as React from 'react';

import Badge from 'bundles/unified-description-page-common/components/shared/badges/Badge';

import _t from 'i18n!nls/unified-description-page-common';

const TopInstructorBadge = () => {
  return <Badge>{_t('Top Instructor')}</Badge>;
};

export default TopInstructorBadge;
